import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a81e78a0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\liweicheng\\web-m\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a81e78a0')) {
      api.createRecord('a81e78a0', component.options)
    } else {
      api.reload('a81e78a0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a81e78a0&", function () {
      api.rerender('a81e78a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/empty/index.vue"
export default component.exports